  <div class="statistic-leaders">
    <div class="row" *ngIf="statistic.length > 0">
      <div class="leader-title">Бомбардиры</div>
      <div class="param-tabs">
        <a
          *ngFor="let param of playersParams"
          href="javascript:;"
          class="active"
          [ngClass]="{active: playersParam.id === param.id}"
          (click)="playersParam = param"
        >{{ param.title }}</a>
      </div>
      <mtg-statistic-leaders
        [statistic]="statistic"
        [param]="playersParam"
        [seasonId]="seasonId"
      ></mtg-statistic-leaders>
    </div>
    <div class="row" *ngIf="statistic.length > 0">
      <div class="leader-title">Карточки</div>
      <div class="param-tabs">
        <a
          *ngFor="let param of cardsParams"
          href="javascript:;"
          class="active"
          [ngClass]="{active: cardsParam.id === param.id}"
          (click)="cardsParam = param"
        >{{ param.title }}</a>
      </div>
      <mtg-statistic-leaders
        [statistic]="statistic"
        [param]="cardsParam"
        [seasonId]="seasonId"
      ></mtg-statistic-leaders>
    </div>
    <div class="row" *ngIf="statistic.length > 0">
      <div class="leader-title">Вратари</div>
      <div class="param-tabs">
        <a
          *ngFor="let param of goalkeeperParams"
          href="javascript:;"
          class="active"
          [ngClass]="{active: goaltenderLeadersParam.id === param.id}"
          (click)="goaltenderLeadersParam = param"
        >{{ param.title }}</a>
      </div>
      <mtg-statistic-leaders
        [statistic]="statistic"
        [param]="goaltenderLeadersParam"
        [seasonId]="seasonId"
      ></mtg-statistic-leaders>
    </div>
  </div>
